<app-spinner
    [show]="!flagLoaded"
    [type]="'fullscreen'"
    [size]="'large'"
    [color]="'#B1476A'"
    [trackColor]="'#4CA7C8'"
    [text]="'Cargando auditoría...'"
    [showText]="true"
    [blurBackground]="true">
</app-spinner>

<div *ngIf="!flagLoaded" style="height: 100vh;"></div>

<div *ngIf="flagLoaded">
<div class="auditoria-header">
  <div class="auditoria-header__accent"></div>
  <div class="container auditoria-header__inner">
    <span class="material-icons auditoria-header__icon">fact_check</span>
    <div>
      <h1 class="auditoria-header__title">Auditoría</h1>
      <p class="auditoria-header__subtitle">Trazabilidad de acciones del sistema</p>
    </div>
  </div>
</div>

<div class="auditoria-area auditoria-animate-in">
  <div class="container">
    <p class="intro">
      Seleccione un componente para ver las acciones auditadas.
    </p>

    <mat-form-field class="buscador" appearance="outline">
      <mat-label>Buscar componente</mat-label>
      <span class="material-icons" matPrefix>search</span>
      <input
        matInput
        [ngModel]="termino"
        (ngModelChange)="aplicarFiltro($event)"
        placeholder="Coseguros, planes, administradores..."
        autocomplete="off"
      />
    </mat-form-field>

    <div class="cards-grid">
      <div
        class="audit-card"
        *ngFor="let comp of componentesFiltrados"
        (click)="entrar(comp)"
      >
        <div class="audit-card__icon">
          <span class="material-icons">{{ comp.icono }}</span>
        </div>
        <h3>{{ comp.titulo }}</h3>
        <p>{{ comp.descripcion }}</p>
        <span
          class="badge"
          [ngClass]="{
            'badge--afiliados': comp.audiencia === 'Afiliados',
            'badge--admin': comp.audiencia === 'Administradores'
          }"
        >
          {{ comp.audiencia }}
        </span>
        <a class="link-btn">Ver auditoría</a>
  </div>
</div>
</div>

    <div class="sin-resultados" *ngIf="componentesFiltrados.length === 0">
      No se encontraron componentes para "{{ termino }}".
    </div>
  </div>
</div>
